import Navigator from 'app';
const HouseMeetingCollection = Backbone.Collection.extend({
  model: Backbone.Model.extend(),
  initialize: function (method, date) {
    this.date = date;
    this.chamber = "house"; // used by committee_meeting_collectionview to determine which chamber's data to request
    this.url = Navigator.config.api_base + 'meetings/house/' + method + '/' + date;
  }
});
const API = {
  getHouseMeetings: function getHouseMeetings(method, date) {
    var defer = $.Deferred();
    var houseMeetings = new HouseMeetingCollection(method, date);
    houseMeetings.fetch({
      dataType: "json",
      success: function (data) {
        defer.resolve(data);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("meetings:house", (method, date) => {
  return API.getHouseMeetings(method, date);
});
export { HouseMeetingCollection as default };